<script setup>
import IconPartnerAvito from "@js/components/Icons/IconPartnerAvito.vue";
import IconPartnerYandex360 from "@js/components/Icons/IconPartnerYandex360.vue";
import IconPartnerBitrix24 from "@js/components/Icons/IconPartnerBitrix24.vue";
import IconPartnerWazzup from "@js/components/Icons/IconPartnerWazzup.vue";
import IconPartnerTimewebCloud from "@js/components/Icons/IconPartnerTimewebCloud.vue";
import IconPartnerJivo from "@js/components/Icons/IconPartnerJivo.vue";
import IconPartnerElama from "@js/components/Icons/IconPartnerElama.vue";
import IconPartnerYandexBusiness from "@js/components/Icons/IconPartnerYandexBusiness.vue";
import IconPartnerMegafon from "@js/components/Icons/IconPartnerMegafon.vue";
import IconPartnerTimeweb from "@js/components/Icons/IconPartnerTimeweb.vue";
import IconPartnerUniSender from "@js/components/Icons/IconPartnerUniSender.vue";
import IconPartnerSmsAero from "@js/components/Icons/IconPartnerSmsAero.vue";
import IconPartnerYandexDirect from "@js/components/Icons/IconPartnerYandexDirect.vue";

const firstRow = [
    { name: "Avito", icon: IconPartnerAvito },
    { name: "Яндекс 360", icon: IconPartnerYandex360 },
    { name: "Яндекс Директ", icon: IconPartnerYandexDirect },
    { name: "Bitrix24", icon: IconPartnerBitrix24 },
    { name: "Wazzup", icon: IconPartnerWazzup },
    { name: "Timeweb Cloud", icon: IconPartnerTimewebCloud },
    { name: "UniSender", icon: IconPartnerUniSender },
];

const secondRow = [
    { name: "Jivo", icon: IconPartnerJivo },
    { name: "eLama", icon: IconPartnerElama },
    { name: "Yandex Business", icon: IconPartnerYandexBusiness },
    { name: "Megafon", icon: IconPartnerMegafon },
    { name: "Timeweb", icon: IconPartnerTimeweb },
    { name: "SMS Aero", icon: IconPartnerSmsAero },
];

const firstRowLoop = [...firstRow, ...firstRow];
const secondRowLoop = [...secondRow, ...secondRow];
</script>

<template>
    <section
        class="relative py-14 "

    >
        <div class="container">
            <div class="mb-8 flex items-end justify-between gap-6 max-[900px]:mb-6 max-[900px]:flex-col max-[900px]:items-start">
                <div class="max-w-[760px]">
                    <p class="mb-[10px] text-xs font-semibold uppercase leading-[1.2] tracking-[0.08em] text-[#8a9099]">
                        Интеграции и партнёрская экосистема
                    </p>

                    <h2 class="mb-3 text-2xl font-extrabold leading-none uppercase tracking-[-0.04em] text-[#111111] md:text-4xl">
                        Наши партнёры
                    </h2>

                    <p class="max-w-[700px] text-base leading-[1.65] text-[#616977] max-md:text-[15px]">
                        Работаем с сервисами, которые помогают выстраивать продажи,
                        коммуникации, аналитику, облачную инфраструктуру и
                        автоматизацию бизнес-процессов.
                    </p>
                </div>

                <div class="shrink-0">
                    <div
                        class="inline-flex min-h-14 items-center gap-[10px] rounded-[18px] border border-black/10 bg-white/70 px-[18px] py-[14px] text-sm font-semibold text-slate-800 shadow-lg"
                    >
                        <span class="text-2xl font-extrabold leading-none text-[#ffc400]">20+</span>
                        Активных партнёрских интеграций
                    </div>
                </div>
            </div>

            <div class="relative py-[18px]">
                <div
                    class="pointer-events-none absolute bottom-0 left-0 top-0 z-[3] w-[92px] max-md:w-[36px]"
                    style="background: linear-gradient(90deg, #fff 0%, rgba(237, 240, 244, 0) 100%)"
                ></div>

                <div
                    class="pointer-events-none absolute bottom-0 right-0 top-0 z-[3] w-[92px] max-md:w-[36px]"
                    style="background: linear-gradient(270deg, #fff 0%, rgba(237, 240, 244, 0) 100%)"
                ></div>

                <div class="overflow-x-hidden">
                    <div class="partners-track partners-track--forward flex w-max gap-[18px] will-change-transform">
                        <div
                            v-for="(partner, index) in firstRowLoop"
                            :key="`top-${partner.name}-${index}`"
                            class="flex h-[132px] w-[250px] min-w-[250px] flex-col justify-between rounded-[24px] border border-black/10 bg-white/90 px-[18px] pb-4 pt-[18px] shadow-sm transition-all duration-300 hover:border-baseColor hover:shadow max-md:h-[116px] max-md:w-[210px] max-md:min-w-[210px] max-md:rounded-[20px] max-md:px-[14px] max-md:pb-[14px] max-md:pt-4"
                        >
                            <div class="partner-logo flex min-h-[56px] flex-1 items-center justify-start max-md:min-h-[48px]">
                                <component :is="partner.icon" />
                            </div>

                            <div class="text-[13px] font-semibold leading-[1.3] text-[#6b7280]">
                                {{ partner.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-[18px] overflow-hidden">
                    <div class="partners-track partners-track--reverse flex w-max gap-[18px] will-change-transform">
                        <div
                            v-for="(partner, index) in secondRowLoop"
                            :key="`bottom-${partner.name}-${index}`"
                            class="flex h-[132px] w-[250px] min-w-[250px] flex-col justify-between rounded-[24px] border border-black/10 bg-white/90 px-[18px] pb-4 pt-[18px] shadow-sm transition-all duration-300 hover:border-baseColor hover:shadow max-md:h-[116px] max-md:w-[210px] max-md:min-w-[210px] max-md:rounded-[20px] max-md:px-[14px] max-md:pb-[14px] max-md:pt-4"
                        >
                            <div class="partner-logo flex min-h-[56px] flex-1 items-center justify-start max-md:min-h-[48px]">
                                <component :is="partner.icon" />
                            </div>

                            <div class="text-[13px] font-semibold leading-[1.3] text-[#6b7280]">
                                {{ partner.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.partner-logo :deep(svg) {
    display: block;
    max-width: 150px;
    max-height: 40px;
    width: auto;
    height: auto;
}

@media (max-width: 768px) {
    .partner-logo :deep(svg) {
        max-width: 130px;
        max-height: 34px;
    }
}

.partners-track--forward {
    animation: partnersMarquee 34s linear infinite;
}

.partners-track--reverse {
    animation: partnersMarqueeReverse 36s linear infinite;
}

/*@media (min-width: 768px) {
    section:hover .partners-track--forward,
    section:hover .partners-track--reverse {
        animation-play-state: paused;
    }
}*/

@keyframes partnersMarquee {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(calc(-50% - 9px));
    }
}

@keyframes partnersMarqueeReverse {
    0% {
        transform: translateX(calc(-50% - 9px));
    }
    100% {
        transform: translateX(0);
    }
}
</style>
